var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"block",class:[_vm.sectionClass],style:({ height: _vm.sectionHeight })},[_c('div',{ref:"parallax",class:[
      _vm.parallax ? _vm.parallaxClass : '',
      _vm.fixed ? _vm.fixedClass : '',
      _vm.containerClass
    ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }